import { render, staticRenderFns } from "./SupplierReturnItemDetails.vue?vue&type=template&id=a8fe057a&scoped=true&"
import script from "./SupplierReturnItemDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupplierReturnItemDetails.vue?vue&type=style&index=0&id=a8fe057a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fe057a",
  null
  
)

export default component.exports